/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Pagination } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import classNames from 'classnames';

export const paging = ({
  movePage, // 페이지 이동
  currentPage, // 현재 페이지 번호
  perPage, // 페이지 노출 데이터 수
  length, // 페이징 노출 수
  totalCount // 전체 데이터 수
}) => {
  // paginator
  const Paginator = require('paginator');

  // state
  const [pages, setPages] = useState([]);

  const [onPaging, setOnPaging] = useState({
    previousBtn: false,
    nextBtn: false,
    firstPage: 0,
    lastPage: 0
  });

  // watch
  useEffect(() => {
    /**
     * paginator Data
     * perPage: 페이지 노출 데이터 수
     * length: 페이목록 수
     * totalCount: data totalCount
     * currentPage: 현재 페이지 번호
     * first_page: 페이지 처음 번호
     * last_page: 페이지 마지막 번호
     */
    const paginator = new Paginator(perPage, length).build(
      totalCount,
      currentPage
    );

    setOnPaging({
      ...onPaging,
      previousBtn: paginator.has_previous_page,
      nextBtn: paginator.has_next_page,
      firstPage: 1,
      lastPage: paginator.total_pages
    });

    const pagesData = new Array(paginator.pages)
      .fill(paginator.first_page)
      .map((value, index) => value + index);
    setPages(pagesData);
  }, [currentPage]);

  return (
    <Flex alignItems="center" justifyContent="center">
      <Pagination size="sm">
        {onPaging.previousBtn && (
          <Pagination.First
            className={classNames({ disabled: !onPaging.previousBtn })}
            onClick={() => movePage(onPaging.firstPage)}
          />
        )}
        {onPaging.previousBtn && (
          <Pagination.Prev
            className={classNames({ disabled: !onPaging.previousBtn })}
            onClick={() => movePage(currentPage - 1)}
          />
        )}
        {pages.map(page => (
          <Pagination.Item
            key={page}
            className={classNames({ active: currentPage === page })}
            onClick={() => movePage(page)}
          >
            {page}
          </Pagination.Item>
        ))}
        {onPaging.nextBtn && (
          <Pagination.Next
            className={classNames({ disabled: !onPaging.nextBtn })}
            onClick={() => movePage(currentPage + 1)}
          />
        )}
        {onPaging.nextBtn && (
          <Pagination.Last
            className={classNames({ disabled: !onPaging.nextBtn })}
            onClick={() => movePage(onPaging.lastPage)}
          />
        )}
      </Pagination>
    </Flex>
  );
};

export default paging;
